import { ClockCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Button, Flex, Result, theme } from 'antd';
import { useAuth } from 'react-oidc-context';

// Resolved against our origin, so `//host` or `/\host` cannot smuggle in another host
const returnPath = () => {
  const from = new URL(new URLSearchParams(window.location.search).get('from') ?? '/', window.location.origin);
  return from.origin === window.location.origin ? from.pathname + from.search + from.hash : '/';
};

export const SessionExpired = () => {
  const auth = useAuth();
  const { token } = theme.useToken();

  return (
    <Flex justify="center">
      <Result
        className={css`
          max-width: 800px;
        `}
        icon={<ClockCircleOutlined style={{ color: token.colorTextSecondary }} />}
        title="Sitzung abgelaufen"
        subTitle="Ihre Anmeldung bei labcomplete® ist abgelaufen. Melden Sie sich erneut an, um weiterzuarbeiten."
        extra={
          <Button type="primary" onClick={() => auth.signinRedirect({ redirect_uri: window.location.origin + returnPath() })}>
            Erneut anmelden
          </Button>
        }
      />
    </Flex>
  );
};
